<template>
  <v-card style="min-width: 65vw; overflow: auto" :loading="true">
    <v-container class="pa-0">
      <v-progress-linear
        v-show="loading"
        style="position: sticky; top: 0; z-index: 10"
        indeterminate
        class="ma-0"
      />
      <VLayout row wrap>
        <VFlex xs6 class="pa-1">
          <v-data-table
            :headers="headers"
            :items="separatedDocuments"
            disable-initial-sort
            rows-per-page-text="Vrstic na stran"
            :rows-per-page-items="[10]"
            class="ma-1"
          >
            <template v-slot:items="props">
              <tr
                :style="
                  props.item == selectedSeparatedDocument
                    ? 'background: #e0e7e6; cursor: pointer;'
                    : 'background: none; cursor: pointer;'
                "
                @click="showSelectedSeperatedDocument(props.item)"
              >
                <td>
                  {{ props.item.fileNameShort }}
                </td>
                <td>
                  {{ props.item.fileName }}
                </td>
                <td>
                  {{ props.item.fromPage }}
                </td>
                <td>
                  {{ props.item.toPage }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </VFlex>
        <VFlex xs6 style="height: 65vh">
          <Viewer
            id="confrim-split-viewer"
            v-if="attachment"
            :file="selectedSeparatedDocument.file"
            :fileName="selectedSeparatedDocument.fileNameShort"
          ></Viewer>
        </VFlex>
      </VLayout>
    </v-container>
    <v-card-actions>
      <v-spacer />
      <v-btn color="red" style="color: white" :disabled="loading" @click="$emit('close-dialog')">
        Prekliči
      </v-btn>
      <v-btn color="primary" :disabled="loading" @click="uploadSplitFiles"> Potrdi </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { axiosInstance } from '../../services/api';
import { mapGetters } from 'vuex';
import Viewer from '@/components/preview/Viewer.vue';

export default {
  name: 'ConfirmSplitting',
  components: { Viewer },
  props: {
    separatedDocuments: {
      type: Array,
      default: null,
    },
    attachment: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Kratko ime datoteke', value: 'fileNameShort' },
        { text: 'Ime datoteke', value: 'fileName' },
        { text: 'Prva stran', value: 'fromPage' },
        { text: 'Zadnja stran ', value: 'toPage' },
      ],
      selectedSeparatedDocument: { file: '', fileName: '', fileNameShort: '' },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['pagination_splitting']),
    numberOfPages() {
      return this.selectedSeparatedDocument.toPage - this.selectedSeparatedDocument.fromPage + 1;
    },
  },
  watch: {
    separatedDocuments: {
      handler(value) {
        if (value) {
          // eslint-disable-next-line prefer-destructuring
          this.selectedSeparatedDocument = value[0];
        }
      },
    },
  },
  methods: {
    showSelectedSeperatedDocument(document) {
      this.selectedSeparatedDocument = document;
    },
    async createReceivedInvoice(file, fileNameShort, fileNameFull, createdAt, attachmentUrl) {
      const formData = new FormData();
      formData.append('file', new Blob([file], { type: 'application/pdf' }), fileNameShort);
      formData.append('file_name', fileNameFull);
      formData.append('status', 'CR');
      formData.append('created_at', createdAt);
      formData.append('attachment', attachmentUrl);

      const response = await axiosInstance.post('/received-invoices/', formData);
      if (response.status > 201) {
        throw new Error('Uploading');
      }
      return response;
    },
    async uploadSplitFiles() {
      this.loading = true;
      try {
        // eslint-disable-next-line max-len
        await Promise.all(
          this.separatedDocuments.map((seperatedDocument) =>
            this.createReceivedInvoice(
              seperatedDocument.file,
              seperatedDocument.fileNameShort,
              seperatedDocument.fileName,
              this.attachment.created_at,
              this.attachment.url
            )
          )
        );

        await axiosInstance.patch(this.attachment.url, { status: 'SP' });
        await this.$store.dispatch(
          'getUnprocessedAttachmentList',
          this.pagination_splitting.current
        );
        this.$store.dispatch('setSnackBarStateAction', {
          snackBar: true,
          color: 'success',
          text: 'Priponke so bile uspešno naložene v procesiranje.',
        });
        this.$emit('clearDocument');
      } catch (err) {
        this.$store.dispatch('setSnackBarStateAction', {
          snackBar: true,
          color: 'red',
          text: 'Napaka pri nalaganju ločenih dokumentov. Kontaktirajte administratorja',
        });
      }
      this.loading = false;
      this.$emit('uploadingFinished');
    },
  },
};
</script>
